import { API_ENDPOINTS } from 'common/constants';
import Api from './ApiWorker';

export const me = () => Api.send(API_ENDPOINTS.me, 'POST', {}, true);
export const checkIP = () => Api.send(API_ENDPOINTS.checkIP, 'POST', {});
export const checkSecurity = () => Api.post(API_ENDPOINTS.checkSecurity, {}, true);

export const getSettings = () => Api.get(API_ENDPOINTS.getSettings);
export const updateSettings = data => Api.send(API_ENDPOINTS.updateSettings, 'POST', data, true);

export const getCategories = () => Api.get(API_ENDPOINTS.getCategories);
export const updateCategory = data => Api.post(API_ENDPOINTS.updateCategory, data, true);
export const createCategory = data => Api.post(API_ENDPOINTS.createCategory, data, true);
export const deleteCategory = data => Api.post(API_ENDPOINTS.deleteCategory, data, true);

export const getItems = data => Api.get(`${API_ENDPOINTS.getItems}?categoryId=${data.categoryId}`);
export const updateItem = data => Api.post(API_ENDPOINTS.updateItem, data, true);
export const deleteItem = data => Api.post(API_ENDPOINTS.deleteItem, data, true);

export const getPeopleItems = data => Api.get(`${API_ENDPOINTS.getPeopleItems}?categoryId=${data.categoryId}`);
export const getParticipant = data => Api.get(`${API_ENDPOINTS.getParticipant}?participantId=${data.participantId}`);

export const getCategoryScores = data => Api.post(API_ENDPOINTS.getCategoryScores, data, true);
export const getSubmissions = data => Api.send(API_ENDPOINTS.getSubmissions, 'POST', data, true);
export const submitSelection = data => Api.send(API_ENDPOINTS.submitSelection, 'POST', data, true);
export const getAllVotedUsersSize = () => Api.get(API_ENDPOINTS.getAllVotedUsersSize, {}, true);
export const submitInfo = data => Api.send(API_ENDPOINTS.submitInfo, 'POST', data);
